/* eslint-disable simple-import-sort/sort, sort-keys-fix/sort-keys-fix */
/*
 * This code is generated by ../../scripts/generateSchemas.ts.
 * Do not adapt manually. Instead run 'yarn generate'.
 */

import { VisualExerciseV0Definition } from './visual-exercise/v0';
import { VisualExerciseV1Definition } from './visual-exercise/v1';
import { VideoExerciseV0Definition } from './video-exercise/v0';
import { VideoExerciseV1Definition } from './video-exercise/v1';
import { RemoteDesktopExerciseV0Definition } from './remote-desktop-exercise/v0';
import { RemoteDesktopExerciseV1Definition } from './remote-desktop-exercise/v1';
import { RemoteDesktopExerciseV2Definition } from './remote-desktop-exercise/v2';
import { RemoteDesktopExerciseV3Definition } from './remote-desktop-exercise/v3';
import { RemoteDesktopExerciseV4Definition } from './remote-desktop-exercise/v4';
import { RemoteDesktopExerciseV5Definition } from './remote-desktop-exercise/v5';
import { PureMultipleChoiceExerciseV0Definition } from './pure-multiple-choice-exercise/v0';
import { PureMultipleChoiceExerciseV1Definition } from './pure-multiple-choice-exercise/v1';
import { PureMultipleChoiceExerciseV2Definition } from './pure-multiple-choice-exercise/v2';
import { PureMultipleChoiceExerciseV3Definition } from './pure-multiple-choice-exercise/v3';
import { PromptingExerciseV0Definition } from './prompting-exercise/v0';
import { MultiStepCodingExerciseV0Definition } from './multi-step-coding-exercise/v0';
import { GpuExerciseV0Definition } from './gpu-exercise/v0';
import { ExplorableExerciseV0Definition } from './explorable-exercise/v0';
import { ExplorableExerciseV1Definition } from './explorable-exercise/v1';
import { ExplorableExerciseV2Definition } from './explorable-exercise/v2';
import { DragAndDropExerciseV0Definition } from './drag-and-drop-exercise/v0';
import { DragAndDropExerciseV1Definition } from './drag-and-drop-exercise/v1';
import { DragAndDropExerciseV2Definition } from './drag-and-drop-exercise/v2';
import { DatalabExerciseV0Definition } from './datalab-exercise/v0';
import { CloudExerciseV0Definition } from './cloud-exercise/v0';
import { CloudExerciseV1Definition } from './cloud-exercise/v1';
import { CloudExerciseV2Definition } from './cloud-exercise/v2';
import { ChatExerciseV0Definition } from './chat-exercise/v0';
import { ChatExerciseV1Definition } from './chat-exercise/v1';
import { ChatExerciseV2Definition } from './chat-exercise/v2';
import { AiFirstCodingExerciseV0Definition } from './ai-first-coding-exercise/v0';
import { IDEExerciseV0Definition } from './ide-exercise/v0';
import { IDEExerciseV1Definition } from './ide-exercise/v1';
import { IDEExerciseV2Definition } from './ide-exercise/v2';
import { IDEExerciseV3Definition } from './ide-exercise/v3';
export * from './visual-exercise/v0';
export * from './visual-exercise/v1';
export * from './video-exercise/v0';
export * from './video-exercise/v1';
export * from './remote-desktop-exercise/v0';
export * from './remote-desktop-exercise/v1';
export * from './remote-desktop-exercise/v2';
export * from './remote-desktop-exercise/v3';
export * from './remote-desktop-exercise/v4';
export * from './remote-desktop-exercise/v5';
export * from './pure-multiple-choice-exercise/v0';
export * from './pure-multiple-choice-exercise/v1';
export * from './pure-multiple-choice-exercise/v2';
export * from './pure-multiple-choice-exercise/v3';
export * from './prompting-exercise/v0';
export * from './multi-step-coding-exercise/v0';
export * from './gpu-exercise/v0';
export * from './explorable-exercise/v0';
export * from './explorable-exercise/v1';
export * from './explorable-exercise/v2';
export * from './drag-and-drop-exercise/v0';
export * from './drag-and-drop-exercise/v1';
export * from './drag-and-drop-exercise/v2';
export * from './datalab-exercise/v0';
export * from './cloud-exercise/v0';
export * from './cloud-exercise/v1';
export * from './cloud-exercise/v2';
export * from './chat-exercise/v0';
export * from './chat-exercise/v1';
export * from './chat-exercise/v2';
export * from './ai-first-coding-exercise/v0';
export * from './ide-exercise/v0';
export * from './ide-exercise/v1';
export * from './ide-exercise/v2';
export * from './ide-exercise/v3';
export default {
  VisualExercise: {
    v0: VisualExerciseV0Definition,
    v1: VisualExerciseV1Definition
  },
  VideoExercise: {
    v0: VideoExerciseV0Definition,
    v1: VideoExerciseV1Definition
  },
  RemoteDesktopExercise: {
    v0: RemoteDesktopExerciseV0Definition,
    v1: RemoteDesktopExerciseV1Definition,
    v2: RemoteDesktopExerciseV2Definition,
    v3: RemoteDesktopExerciseV3Definition,
    v4: RemoteDesktopExerciseV4Definition,
    v5: RemoteDesktopExerciseV5Definition
  },
  PureMultipleChoiceExercise: {
    v0: PureMultipleChoiceExerciseV0Definition,
    v1: PureMultipleChoiceExerciseV1Definition,
    v2: PureMultipleChoiceExerciseV2Definition,
    v3: PureMultipleChoiceExerciseV3Definition
  },
  PromptingExercise: {
    v0: PromptingExerciseV0Definition
  },
  MultiStepCodingExercise: {
    v0: MultiStepCodingExerciseV0Definition
  },
  GpuExercise: {
    v0: GpuExerciseV0Definition
  },
  ExplorableExercise: {
    v0: ExplorableExerciseV0Definition,
    v1: ExplorableExerciseV1Definition,
    v2: ExplorableExerciseV2Definition
  },
  DragAndDropExercise: {
    v0: DragAndDropExerciseV0Definition,
    v1: DragAndDropExerciseV1Definition,
    v2: DragAndDropExerciseV2Definition
  },
  DatalabExercise: {
    v0: DatalabExerciseV0Definition
  },
  CloudExercise: {
    v0: CloudExerciseV0Definition,
    v1: CloudExerciseV1Definition,
    v2: CloudExerciseV2Definition
  },
  ChatExercise: {
    v0: ChatExerciseV0Definition,
    v1: ChatExerciseV1Definition,
    v2: ChatExerciseV2Definition
  },
  AiFirstCodingExercise: {
    v0: AiFirstCodingExerciseV0Definition
  },
  IDEExercise: {
    v0: IDEExerciseV0Definition,
    v1: IDEExerciseV1Definition,
    v2: IDEExerciseV2Definition,
    v3: IDEExerciseV3Definition
  }
};